import index from "@/views/Index";
import home from "@/views/Home";
import elecboard from "@/views/ElecBoard";
import machstatus from "@/views/MachStatus";
import yieldstatistics from "@/views/YieldStatistics";
import activation from "@/views/Activation";
import operatelog from "@/views/OperateLog";
import workorderhistory from "@/views/WorkorderHistory";
import ordermanagement from "@/views/OrderManagement";
import machmalfunction from "@/views/MachMalfunction";
import statisticstable from "@/views/StatisticsTable"
import heattreatmentinstant from "@/views/heattreatmentinstant"
import operation from "@/views/Operation"
import wireinquire from "@/views/WireInquire";
import heattreatmentparam from "@/views/HeatTreatmentParam";
import pcreport from "@/views/PcReport";
import errorhistory from "@/views/ErrorHistory";

// import pagenotfound from "@/views/PageNotFound";

export const childRouter = [
  {
    path: "/index",
    redirect: "/index/home",//登入位置
    component: index,
    children: [
      {
        path: "home",
        component: home,
        meta: {
          needLogin: true
        }
      },
      { path: "elecboard", component: elecboard, meta: { needLogin: true } },
      { path: "machstatus", component: machstatus, meta: { needLogin: true } },
      { path: "yieldstatistics", component: yieldstatistics, meta: { needLogin: true } },
      { path: "activation", component: activation, meta: { needLogin: true } },
      { path: "operatelog", component: operatelog, meta: { needLogin: true } },
      { path: "errorhistory", component: errorhistory, meta: { needLogin: true } },
      { path: "workorderhistory", component: workorderhistory, meta: { needLogin: true } },
      { path: "ordermanagement", component: ordermanagement, meta: { needLogin: true } },
      { path: "machmalfunction", component: machmalfunction, meta: { needLogin: true } },
      { path: "statisticstable", component: statisticstable, meta: { needLogin: true } },
      { path: "heattreatmentinstant", component: heattreatmentinstant, meta: { needLogin: true } },
      { path: "operation", component: operation, meta: { needLogin: true } },
      { path: "wireinquire", component: wireinquire, meta: { needLogin: true } },
      { path: "heattreatmentparam", component: heattreatmentparam, meta: { needLogin: true } },
      { path: "pcreport", component: pcreport, meta: { needLogin: true } },
    ]
  },
  //   {
  //     path: "/404",
  //     component: pagenotfound
  //   },
];



// WEBPACK FOOTER //
// ./src/router/childRouter.js